// extracted by mini-css-extract-plugin
export var bottomShadow = "hero-module--bottomShadow--oxaqV";
export var lightBlue = "hero-module--lightBlue--drplc";
export var heroContent = "hero-module--heroContent--6tqQ-";
export var heroCopy = "hero-module--heroCopy--VfvFk";
export var heroImage = "hero-module--heroImage--NL-O0";
export var topBar = "hero-module--topBar--oCVJR";
export var topBarActions = "hero-module--topBarActions--PmVE5";
export var logo = "hero-module--logo--KE7Bn";
export var navLink = "hero-module--navLink--qoZHD";
export var title = "hero-module--title--+uEef";
export var subtitle = "hero-module--subtitle--3AMZa";
export var trial = "hero-module--trial---it-m";
export var text = "hero-module--text--JpAk2";